export var ContactSource;
(function (ContactSource) {
    ContactSource["InviteModal"] = "inviteModal";
    ContactSource["EditMemberModal"] = "editMemberModal";
    ContactSource["SubscriptionPlanModal"] = "subscriptionPlanModal";
    ContactSource["SubscriptionPlanModalInterestedInEnterprise"] = "subscriptionPlanModalInterestedInEnterprise";
    ContactSource["BillingAndPlansPage"] = "billingAndPlansPage";
    ContactSource["LockedApps"] = "lockedApps";
    ContactSource["Users"] = "users";
    ContactSource["AddressModal"] = "addressModal";
})(ContactSource || (ContactSource = {}));
//# sourceMappingURL=contactSource.js.map